import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-extraneous-dependencies
import { notify } from 'notiwind';
import { ALL_FILTERS } from '@/constants';

import {
  Get,
} from '@/api/product';

// eslint-disable-next-line import/prefer-default-export
export const useProductsStore = defineStore('products', {
  state: () => ({
    categoryFilter: ALL_FILTERS.value,
    searchTextFilter: null,
    data: [],
    isLoading: false,
  }),
  actions: {
    async Load() {
      this.isLoading = true;
      try {
        const { data: { data } } = await Get();
        this.data = data;
      } catch (error) {
        let message;
        if (error.response) {
          message = error.response.data.message;
        }
        message = message ?? 'An error occured while loading products';
        notify(
          {
            variant: 'bg-red-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      } finally {
        this.isLoading = false;
      }
    },
    SetCategoryFilter(filter) {
      this.categoryFilter = filter;
    },
    SetSearchTextFilter(filter) {
      this.searchTextFilter = filter;
    },
  },
  getters: {
    Data: (state) => state.data,
    CategoryFilter: (state) => state.categoryFilter,
    SearchTextFilter: (state) => state.searchTextFilter,
    FilteredData: (state) => {
      const { categoryFilter, searchTextFilter } = state;
      return state.data
        .filter((d) => (!searchTextFilter || d.name.toLowerCase()
          .includes(searchTextFilter.toLowerCase()))
            && (!categoryFilter || d.categoryId === categoryFilter));
    },
    IsLoading: (state) => state.isLoading,
  },
});
